import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill={props.bgColor || "#F3FAF6"} />
    <G clipPath="url(#clip0_997_4589)">
      <Path
        opacity={0.2}
        d="M27.6664 18.4673C28.3035 17.8077 28.656 16.9243 28.648 16.0073C28.6401 15.0903 28.2723 14.2132 27.6238 13.5647C26.9754 12.9163 26.0982 12.5485 25.1813 12.5405C24.2643 12.5326 23.3808 12.8851 22.7212 13.5221L14.3277 21.9157C13.6906 22.5753 13.3381 23.4587 13.3461 24.3757C13.354 25.2927 13.7219 26.1699 14.3703 26.8183C15.0187 27.4667 15.8959 27.8345 16.8129 27.8425C17.7299 27.8505 18.6133 27.498 19.2729 26.8609L27.6664 18.4673Z"
        fill={props.color || "#0E8741"}
      />
      <Path
        d="M26.5925 19.4922L27.6662 18.4675C28.3033 17.8079 28.6558 16.9244 28.6478 16.0075C28.6398 15.0905 28.272 14.2133 27.6236 13.5649C26.9752 12.9164 26.098 12.5486 25.181 12.5407C24.264 12.5327 23.3806 12.8852 22.721 13.5223L21.6963 14.5959"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.39893}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.4016 20.8906L14.3279 21.9153C13.6909 22.5749 13.3384 23.4584 13.3463 24.3754C13.3543 25.2923 13.7221 26.1695 14.3705 26.8179C15.019 27.4664 15.8961 27.8342 16.8131 27.8421C17.7301 27.8501 18.6135 27.4976 19.2731 26.8605L20.2978 25.7869"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.39893}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M26.5928 22.9893H28.6912"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.39893}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.3027 17.3936H15.4011"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.39893}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M23.7949 25.7871V27.8855"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.39893}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18.1992 12.4971V14.5955"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.39893}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_997_4589">
        <Rect
          width={22.3828}
          height={22.3828}
          fill="white"
          transform="translate(9.80566 9)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
